import { Suspense, type ReactNode } from 'react';
import { useAtomValue } from 'jotai';
import { Box, Spinner } from '@ff-it/ui';
import { PlanStrategyContext, strategyResourceAtom } from './strategy';

function ReadyPlan({ children }: { children: ReactNode }) {
  const strategy = useAtomValue(strategyResourceAtom);
  return <PlanStrategyContext.Provider value={strategy}>{children}</PlanStrategyContext.Provider>;
}

export function LoadingBoundary({ children }: { children: ReactNode }) {
  return (
    <div className="flex-grow-1 flex-column d-flex">
      <Suspense
        fallback={
          <Box py="8" mx="auto" role="status" aria-label="Loading plan">
            <Spinner color="primary" />
          </Box>
        }
      >
        <ReadyPlan>{children}</ReadyPlan>
      </Suspense>
    </div>
  );
}
